<script>
	import {External, M} from '../../../../../external';
	import MessageSentActivityDetail from "./MessageSentActivityDetail.svelte";
	import WebComponents from "../../../../../main";

	export let data, contact;

	const clickHandler = () => {
		switch (data.message.channel) {
			case External.CRM_MESSAGE_CHANNEL.SMS:
				WebComponents.CRM.composeSMS(contact);
				break;
			case External.CRM_MESSAGE_CHANNEL.WHATSAPP:
				WebComponents.CRM.composeWhatsApp(contact);
				break;
		}
	};

</script>

<MessageSentActivityDetail {data} {contact}>
	<svelte:fragment>
		<a class='blue-text' on:click={clickHandler}>{M.REPLY}</a>
	</svelte:fragment>
</MessageSentActivityDetail>
